import type { PatientUserInfo, StorageClient, UserPatient } from "@phurshell/psiapp-frontend-core/domain";
import { PiniaStorageClient } from "@/app/adapters/PiniaStorageClient";
import { useAuthTokenStore } from "@/store/useAuthTokenStore";
import { useSessionStore } from "@/store/useSessionStore";
import { useUserInfoStore } from "@/store/useUserInfoStore";

export const sessionStorageClient: StorageClient<UserPatient> =
  new PiniaStorageClient(() => useSessionStore());

export const authTokenStorageClient: StorageClient<string> =
  new PiniaStorageClient(() => useAuthTokenStore());

export const userInfoStorageClient: StorageClient<PatientUserInfo> =
  new PiniaStorageClient(() => useUserInfoStore());
